module.exports = __webpack_public_path__ + "img/044-boy-19.7cca6d90.svg";